import React from "react";
import classname from "classnames";

import { DetailItemAmountType } from "../types";

const ItemAmount: React.FC<DetailItemAmountType> = ({ value, type }) => {
  const classes = classname("font-semibold shrink-0 sm:ml-auto", {
    "text-teal-170": type === "income",
    "text-red-corporate": type === "expense",
  });

  return <div className={classes}>{value}</div>;
};

export default ItemAmount;
